module.exports = __webpack_public_path__ + "static/media/chat09.0e32272f.gif";